import React from 'react';
import { Button, colors, TableCell, TableRow } from '@insurancemenu/imenu-components-lib';
import {
  CheckCircle,
  InfoButton,
  InfoButtonFilled,
  RadioButtonChecked,
  RadioButtonUnchecked,
} from '@insurancemenu/imenu-components-lib/dist/icons';
import { normDateToAmericanDateTime } from '@insurancemenu/imenu-components-lib/dist/helpers/dateFormatters';
import { useRootStore } from 'store/rootStore';
import { Email, GeneralStatus } from 'types/emailService';
import clsx from 'clsx';
import { createStyles } from './styles';

interface EmailsTableRowProps {
  email: Email;
}

const EmailsTableRow = ({ email }: EmailsTableRowProps): JSX.Element => {
  const classes = createStyles();
  const { emailType, domainId, emailAddress, userTypes, status, creationDateTime } = email;
  const fullDateTime = normDateToAmericanDateTime(`${creationDateTime}`);

  const {
    emailsDashboardStore: { openModal },
  } = useRootStore();

  const openContextModal = async (): Promise<void> => {
    await openModal(email);
  };

  const EMAIL_STATUS: Record<GeneralStatus, JSX.Element> = Object.freeze({
    [GeneralStatus.SENT]: (
      <div className={classes.emailStatus}>
        <span>Sent</span>
        <RadioButtonUnchecked width="2.3rem" height="2.3rem" color={colors.yellow[600]} />
      </div>
    ),
    [GeneralStatus.OPENED]: (
      <div className={classes.emailStatus}>
        <span>Opened</span>
        <CheckCircle width="2.3rem" height="2.3rem" color={colors.green[600]} />
      </div>
    ),
    // Failed Statuses
    [GeneralStatus.BOUNCED]: (
      <div className={classes.emailStatus}>
        <span>Bounced</span>
        <RadioButtonChecked width="2.3rem" height="2.3rem" color={colors.red[600]} />
      </div>
    ),
    [GeneralStatus.FAILED_TO_SEND]: (
      <div className={classes.emailStatus}>
        <span>Failed to send</span>
        <RadioButtonChecked width="2.3rem" height="2.3rem" color={colors.orange[600]} />
      </div>
    ),
    [GeneralStatus.BLOCK]: (
      <div className={classes.emailStatus}>
        <span>Block</span>
        <InfoButtonFilled width="2.3rem" height="2.3rem" color={colors.red[600]} />
      </div>
    ),
    [GeneralStatus.INVALID]: (
      <div className={classes.emailStatus}>
        <span>Invalid</span>
        <RadioButtonChecked width="2.3rem" height="2.3rem" color={colors.red[600]} />
      </div>
    ),
    [GeneralStatus.SPAM]: (
      <div className={classes.emailStatus}>
        <span>Spam</span>
        <RadioButtonChecked width="2.3rem" height="2.3rem" color={colors.red[600]} />
      </div>
    ),
  });
  return (
    <TableRow className={classes.tableRow}>
      <TableCell className={classes.tableCell}>{domainId}</TableCell>
      <TableCell className={classes.tableCell}>{emailType}</TableCell>
      <TableCell className={classes.tableCell}>{emailAddress}</TableCell>
      <TableCell className={classes.tableCell}>{userTypes.join(', ')}</TableCell>
      <TableCell className={clsx(classes.tableCell, classes.emailStatusCell)}>{EMAIL_STATUS[status]}</TableCell>
      <TableCell className={classes.tableCell}>{fullDateTime}</TableCell>
      <TableCell className={classes.tableCell}>
        <Button
          type="text"
          leftIconProp={<InfoButton />}
          color="primary"
          onClick={openContextModal}
          className={classes.actionButton}
        >
          Show Context
        </Button>
      </TableCell>
    </TableRow>
  );
};

export default EmailsTableRow;
